import React from "react";

const OptionField = ({ index, value, label, disabled }) => {
  return (
    <option key={index} value={value} disabled={disabled}>
      {label || value}
    </option>
  );
};

export default OptionField;
